import React, { useEffect } from 'react';
import styles from '../ConfirmationDialog/ConfirmationDialog.module.css';
import localStyles from './RecurrenceDeleteDialog.module.css';

export type RecurrenceDeleteChoice = 'single' | 'forward' | 'series';

interface RecurrenceDeleteDialogProps {
  onChoose: (choice: RecurrenceDeleteChoice) => void;
  onCancel: () => void;
}

const RecurrenceDeleteDialog: React.FC<RecurrenceDeleteDialogProps> = ({ onChoose, onCancel }) => {
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onCancel();
      }
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [onCancel]);

  return (
    <div className={styles.backdrop} onClick={(event) => event.target === event.currentTarget && onCancel()}>
      <div className={`${styles.dialog} ${localStyles.dialog}`} role="dialog" aria-labelledby="recurrence-delete-title">
        <div className={styles.header}>
          <div className={styles.icon}>⚠️</div>
          <h3 id="recurrence-delete-title" className={styles.title}>
            מחיקת הוצאה חוזרת
          </h3>
        </div>
        <div className={styles.message}>
          הוצאה זו חלק מסדרה חוזרת. מה ברצונך למחוק?
        </div>
        <div className={`${styles.actions} ${localStyles.actions}`}>
          <button type="button" className={`${styles.button} ${localStyles.optionButton}`} onClick={() => onChoose('single')}>
            מחק רק את ההוצאה הזו
          </button>
          <button type="button" className={`${styles.button} ${localStyles.optionButton}`} onClick={() => onChoose('forward')}>
            מחק את כל ההוצאות העתידיות מהיום והלאה
          </button>
          <button
            type="button"
            className={`${styles.button} ${styles.confirmButton} ${styles.danger} ${localStyles.optionButton}`}
            onClick={() => onChoose('series')}
          >
            מחק את כל הסדרה, כולל העבר
          </button>
          <button type="button" className={`${styles.button} ${styles.cancelButton}`} onClick={onCancel} autoFocus>
            ביטול
          </button>
        </div>
      </div>
    </div>
  );
};

export default RecurrenceDeleteDialog;
